import type React from 'react'

export const IconStack: React.FC<{ width?: number }> = ({ width }) => (
  <svg
    width={width || 17}
    height={width || 16}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.08007 13.993C4.11193 14.1493 4.15675 14.2842 4.21983 14.408C4.41158 14.7843 4.71754 15.0903 5.09386 15.282C5.52169 15.5 6.08174 15.5 7.20185 15.5H10.4018C12.362 15.5 13.3421 15.5 14.0908 15.1185C14.7494 14.783 15.2848 14.2475 15.6204 13.589C16.0018 12.8403 16.0018 11.8602 16.0018 9.9V6.7C16.0018 5.57989 16.0018 5.01984 15.7839 4.59202C15.5921 4.21569 15.2862 3.90973 14.9098 3.71799C14.7853 3.65455 14.6496 3.60958 14.4922 3.57769C14.4993 3.92919 14.4993 4.33201 14.4993 4.8V6.02699C14.5016 6.21056 14.5018 6.4301 14.5018 6.7V9.9C14.5018 10.9048 14.5007 11.5683 14.4591 12.0766C14.419 12.5675 14.3489 12.7803 14.2839 12.908C14.0921 13.2843 13.7862 13.5903 13.4098 13.782C13.2822 13.847 13.0694 13.9172 12.5785 13.9573C12.0701 13.9988 11.4067 14 10.4018 14L9.69925 14L7.20185 14C7.19258 14 7.18337 14 7.17422 14H5.29926C4.83265 14 4.43084 14 4.08007 13.993Z"
      fill="currentColor"
    />
    <rect
      x="1.75"
      y="1.25"
      width="10.5"
      height="10.5"
      rx="1.25"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="4.5"
      y="3.5"
      width="5"
      height="1.5"
      rx="0.75"
      fill="currentColor"
    />
  </svg>
)
